import { IconType } from 'react-icons';
import { FaCashRegister } from "react-icons/fa";
// Modern Enterprise Icons - Consistent and Professional
import { 
  HiOutlineHome,
  HiOutlineBanknotes,
  HiOutlineUsers,
  HiOutlineCog6Tooth,
  HiOutlineClipboardDocumentList,
  HiOutlineShoppingBag,
  HiOutlineDocumentText,
  HiOutlineReceiptRefund,
  HiOutlineArrowTrendingUp,
  HiOutlineChartBar,
  HiOutlineGlobeAlt,
  HiOutlineTicket,
  HiOutlineChatBubbleLeftRight,
  HiOutlineBuildingOffice2,
  HiOutlinePrinter,
  HiOutlineComputerDesktop,
  HiOutlineUserGroup,
  HiOutlineWrenchScrewdriver,
  HiOutlineCubeTransparent,
  HiOutlineSquares2X2,
  HiOutlinePuzzlePiece,
  HiOutlineBeaker,
  HiOutlineSparkles,
  HiOutlineClipboardDocumentCheck,
  HiOutlineArchiveBox,
  HiOutlineBuildingStorefront,
  HiOutlineInboxStack,
  HiOutlineCalendarDays,
} from 'react-icons/hi2';
import {FaPlug} from 'react-icons/fa6';
import { 
  TbTruckDelivery,
  TbChefHat,
  TbReportAnalytics
} from 'react-icons/tb';



export type MenuSubOption = {
    name: string;
    route: string;
    icon?: IconType;
  };
  
export  type MenuOption = {
    name: string;
    route: string | null;
    icon: IconType;
    suboptions?: MenuSubOption[]; // Make suboptions optional
  };

type Guard = number | 'superadmin' | 'free';


const permissionByRoute: Record<string, Guard> = {
  // Finanzas
  '/App/CajasManagement': 1,
  '/App/Receipts': 2,
  '/App/Ventas': 4,
  '/App/Transactions': 57,

  // Clientes
  '/App/OnlineMenuManagement': 'free',     // sin restricción (como en tus Routes)
  '/App/CuponesDescuentos': 29,
  '/App/Clients': 'free', //@TODO pending permission definition
  '/App/ReviewsSummary': 'superadmin',
  '/App/ReservationManagement': 25,

  // Configuración
  '/App/AjustesPermisos': 'superadmin',
  '/App/Workstations': 45,
  '/App/Terminals': 49,
  '/App/Puestos': 43,
  '/App/PaginaSalones': 62,
  '/App/Usuarios': 'superadmin',
  '/App/Integrations': 'superadmin',

  // Menú
  '/App/Categories': 18,
  '/App/SelectionGroups': 66,       // si cambia, ajusta aquí
  '/App/SelectionModifiers': 66,    // mismo permiso que arriba
  '/App/Ingredients': 22,
  '/App/Items': 20,
  '/App/Menus': 15,

  // Pedidos
  '/App/VentaCaja': 68,
  '/App/ModificacionesPedidos': 70,
  '/App/CambiosPrecios': 70,
  '/App/Delivery': 81,
  '/App/HistorialDePedidos': 52,
  '/KDS': 'free',
  '/App/Restaurant': 82,
  '/App/PedidosConfig': 'free',

  // Gestión
  '/App/StorageUnits': 72,
  '/App/Bills': 74,
  '/App/Compras': 76,
  '/App/Salarios': 78,
  '/App/Providers': 34,
  '/App/Stock': 14,

  // Otros abiertos
  '/App/Utilities': 'free',
  '/App/Recommendations': 'free',
  '/App/UserProfile': 'free',
  '/App/Support': 'free',
};

const canAccessRoute = (
  route: string | null | undefined,
  getPermissionState: (id: number) => boolean,
  isSuperAdmin: () => boolean,
  delegatedSettings = false
) => {
  if (!route || route === 'null') return true; // grupos/headers
  if (route === '/App/AjustesPermisos' && delegatedSettings) return true;
  const guard = permissionByRoute[route];

  if (guard === 'free' || guard === undefined) return true; // sin restricción
  if (guard === 'superadmin') return isSuperAdmin();
  return getPermissionState(guard);
};

export const getVisibleMenuObject = (
  getPermissionState: (id: number) => boolean,
  isSuperAdmin: () => boolean,
  delegatedSettings = false
): MenuOption[] => {
  return menuObject
    .map((opt) => {
      // filtra subopciones por permiso
      const visibleSubs = (opt.suboptions ?? []).filter((so) =>
        canAccessRoute(so.route, getPermissionState, isSuperAdmin, delegatedSettings)
      );

      // si el grupo tiene route “clickable”, validamos el propio grupo;
      // si es “null” (grupo), lo mostramos solo si quedan subopciones visibles
      const isClickable = !!opt.route && opt.route !== 'null';
      const showSelf = isClickable
        ? canAccessRoute(opt.route, getPermissionState, isSuperAdmin, delegatedSettings)
        : visibleSubs.length > 0;

      return showSelf ? { ...opt, suboptions: visibleSubs } : null;
    })
    .filter(Boolean) as MenuOption[];
};


export const menuObject: MenuOption[] = [
    {
      name:"Finanzas",
      route:"null",
      icon: HiOutlineBanknotes,
      suboptions:[
        {name:"Cajas",route:"/App/CajasManagement", icon: FaCashRegister,},
        {name:"Gastos",route:"/App/Compras", icon: HiOutlineShoppingBag},
        {name:"Recibos",route:"/App/Receipts", icon: HiOutlineReceiptRefund},
        {name:"Transacciones",route:"/App/Transactions", icon: HiOutlineArrowTrendingUp,},
        {name:"Ventas",route:"/App/Ventas", icon: HiOutlineChartBar},
      ],
    },
    {
      name:"Clientes",
      route:"null",
      icon: HiOutlineUsers,
      suboptions:[
       {name:"Mi Punto Digital",route:"/App/OnlineMenuManagement", icon: HiOutlineGlobeAlt},
        {name:"Cupones y Descuentos",route:"/App/CuponesDescuentos", icon: HiOutlineTicket},
        {name:"Fidelización",route:"/App/Clients", icon: HiOutlineUsers},
        {name:"Reseñas y Feedback",route:"/App/ReviewsSummary", icon: HiOutlineChatBubbleLeftRight},
        {name:"Reservaciones",route:"/App/ReservationManagement", icon: HiOutlineCalendarDays},
        
      ],
    },
  
    {
      name:"Configuración",
      route:"null",
      icon: HiOutlineCog6Tooth,
      suboptions:[
        {name:"Ajustes y permisos",route:"/App/AjustesPermisos", icon: HiOutlineWrenchScrewdriver},
        {name:"Integraciones",route:"/App/Integrations", icon: FaPlug},
        {name:"Estaciones de trabajo",route:"/App/Workstations", icon: HiOutlineComputerDesktop},
        {name:"Impresoras y dispositivos",route:"/App/Terminals", icon: HiOutlinePrinter},
        {name:"Puestos de trabajo",route:"/App/Puestos", icon: HiOutlineBuildingOffice2},
        {name:"Salones",route:"/App/PaginaSalones", icon: HiOutlineSquares2X2},
        {name:"Usuarios",route:"/App/Usuarios", icon: HiOutlineUserGroup},
      ],
    },
    {
      name:"Menú",
      route:"null",
      icon: TbChefHat,
      suboptions:[
        {name:"Categorías",route:"/App/Categories", icon: HiOutlineSquares2X2},
        {name:"Combos y Extras",route:"/App/SelectionGroups", icon: HiOutlineCubeTransparent},
        {name:"Grupos de modificadores",route:"/App/SelectionModifiers", icon: HiOutlinePuzzlePiece},
        {name:"Ingredientes",route:"/App/Ingredients", icon: HiOutlineBeaker},
        {name:"Items",route:"/App/Items", icon: HiOutlineSparkles},
        {name:"Menú",route:"/App/Menus", icon: HiOutlineClipboardDocumentList},
      ],
    },
    {
      name: "Pedidos",
      route: "null",
      icon: HiOutlineClipboardDocumentCheck,
      suboptions:[
        //{name:"Caja",route:"/App/VentaCaja", icon:  FaCashRegister},
        //{name:"Delivery",route:"/App/Delivery", icon: TbTruckDelivery},
        {name:"Historial De Pedidos",route:"/App/HistorialDePedidos", icon: HiOutlineDocumentText},
        {name:"KDS",route:"/KDS", icon: HiOutlineComputerDesktop},
        {name:"Restaurant",route:"/App/Restaurant", icon: HiOutlineBuildingOffice2},
        {name:"Configuración Pedidos",route:"/App/PedidosConfig", icon: HiOutlineCog6Tooth},  // new addition
      ],
      },

      {
        name: "Gestión",
        route: "null",
        icon: TbReportAnalytics,
        suboptions:[
          {name:"Almacenamiento",route:"/App/StorageUnits", icon: HiOutlineArchiveBox},
          //{name:"Cuentas",route:"/App/Bills", icon: HiOutlineDocumentText},
          {name:"Cambios de Precios",route:"/App/CambiosPrecios", icon: HiOutlineBanknotes},
          {name:"Modificaciones Pedidos",route:"/App/ModificacionesPedidos", icon: HiOutlineDocumentText},
          //{name:"Salarios",route:"/App/Salarios", icon: HiOutlineCurrencyDollar},
          {name:"Proveedores",route:"/App/Providers", icon: HiOutlineBuildingStorefront},
          {name:"Stock",route:"/App/Stock", icon: HiOutlineInboxStack},
          // {name:"Utilidades",route:"/App/Utilities", icon: FaUtensilSpoon},
        ],
        },
  
  
    // Add more menu options here
  ];

  export const menuObjectAdmin: MenuOption[] = [
    {
    name: "",
    route: "/Admin/Home",
    icon: HiOutlineHome,
    suboptions:[]
    },
    {
      name:"Soporte",
      route:"null",
      icon: HiOutlineChatBubbleLeftRight,
      suboptions:[
        {name:"Tickets",route:"/Admin/Tickets"},
      ],
    }
  ];

  export const menuObjectMobile: MenuOption[] = [
    {
      name: "Inicio",
      route: "/App",
      icon: HiOutlineHome,
      suboptions: [],
    },
    ...menuObject
  ];